import React from 'react';
import { useState } from "react";
import getUrl from "../../../Utility/GetUrl";
import { postData } from "../../../Utility/GlobalService";
import TextAreaInput from "../Components/textareaInput";
import TextInput from "../Components/textInput";

const DashboardSocialMedia = ()=> { 
  const [facebookLink,setfacebookLink] = useState("");
  const [linkedInLink,setlinkedInLink] = useState("");
  const [twitterLink,settwitterLink] = useState("");
  const [instagramLink,setinstagramLink] = useState("");
  
  const handleFacebookLinkSubmit = (event)=>{
    event.preventDefault();
    const data = {
      link: facebookLink,
      type: 'facebook'
    };
    postData(`${getUrl()}/social`,data);
    setfacebookLink("");
  }
  const handleTwitterLinkSubmit = (event)=>{
    event.preventDefault();
    const data = {
      link: twitterLink,
      type: 'twitter'
    };
    postData(`${getUrl()}/social`,data);
    settwitterLink("");
  }
  const handleLinkedInLinkSubmit = (event)=>{
    event.preventDefault();
    const data = {
      link: linkedInLink,
      type: 'linkedin'
    };
    postData(`${getUrl()}/social`,data);
    setlinkedInLink("");
  }
  const handleInstagramLinkSubmit = (event)=>{
    event.preventDefault();
    const data = {
      link: instagramLink,
      type: 'instagram'
    };
    postData(`${getUrl()}/social`,data);
    setinstagramLink("");
  }
  const styles = {
    container: {paddingBottom: '350px'}
  }
    return (
      <div className="social-media mb-5" style = {styles.container}>
          <div className="container mb-5">
            <div className="row">
              <div className="col-md-12">
                <h2>Social Media Page</h2>
              </div>
            </div>
            <div className="row mt-5">
            <div className="col-md-5">
              <div className="card">
                <div className="card-body mb-auto">
                  <h5>Facebook</h5>
                  <TextInput
                    title = "Link"
                    handleInputSubmit = {handleFacebookLinkSubmit}
                    setInputValue = {setfacebookLink}
                    inputValue ={facebookLink}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-1"></div>
              <div className="col-md-5">
              <div className="card">
                <div className="card-body mb-auto">
                  <h5>Twitter</h5>
                  <TextInput
                    title = "Link"
                    handleInputSubmit = {handleTwitterLinkSubmit}
                    setInputValue = {settwitterLink}
                    inputValue ={twitterLink}
                  />
                </div>
              </div>
              </div>
            </div>

            <div className="row mt-5">
            <div className="col-md-5">
              <div className="card">
                <div className="card-body mb-auto">
                  <h5>LinkedIn</h5>
                  <TextInput
                    title = "Link"
                    handleInputSubmit = {handleLinkedInLinkSubmit}
                    setInputValue = {setlinkedInLink}
                    inputValue ={linkedInLink}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-1"></div>
              <div className="col-md-5">
              <div className="card">
                <div className="card-body mb-auto">
                  <h5>Instagram</h5>
                  <TextInput
                    title = "Link"
                    handleInputSubmit = {handleInstagramLinkSubmit}
                    setInputValue = {setinstagramLink}
                    inputValue ={instagramLink}
                  />
                </div>
              </div>
              </div>
            </div>
          </div>
      </div>
    );
  }
  
  export default DashboardSocialMedia; 